<div class="return-packaging-step">
  @if (hasChoice()) {
    <return-method-choice
      [settings]="settings()"
      [selected]="store.method()"
      (methodChange)="onMethodChange($event)"
    ></return-method-choice>
  }

  @if (store.method()) {
    @if (hasChoice()) {
      <hr class="return-packaging-step__divider"/>
    }

    @if (store.isSelfReturn()) {
      <self-return-schedule
        [outletId]="settings().returnThemselvesOutlet"
        [earliestDate]="earliestDate()"
        [heading]="'orderProcess.returnPackaging.selfReturn.heading' | translate"
        [instructions]="settings().returnThemselvesInstructionsCheckout"
      ></self-return-schedule>
    }

    @if (store.isCourierReturn()) {
      <courier-return-schedule
        [bakeryId]="bakeryId()"
        [countryCode]="countryCode()"
        [currency]="currency()"
        [pickupLocation]="pickupLocation()"
        [earliestDate]="earliestDate()"
        [heading]="courierHeading() | translate"
        [instructions]="settings().returnCourierInstructionsCheckout"
      ></courier-return-schedule>
    }

    <div class="return-packaging-step__confirm">
      <button class="btn {{ nextBtnView() }} btn-mobile-full-width font-xl return-packaging-step__confirm-btn"
              type="button"
              [disabled]="!store.canSubmit() || isSaving()"
              (click)="submit()">
        <span [translate]="nextBtnTextKey()"></span>
      </button>
    </div>
  }
</div>
